/** @jsxImportSource @emotion/react */

import { useEffect, useState } from "react";
import UI from "@mile-meeting/mile-ui";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

export const PwEyeIconTouchPoint = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  top: 18px;
  right: 14px;
`;

const PasswordInput = ({
  placeholder,
  onChange,
  error,
  helpText,
  showHelpText = false,
}: {
  placeholder?: string;
  onChange?: (value: string) => void;
  error?: boolean;
  helpText?: string;
  showHelpText?: boolean;
}) => {
  const [showPw, setShowPw] = useState<boolean>(false);
  const passwordRef = React.useRef<HTMLInputElement>(null);

  //* INFO: 자동완성 기능을 위한 이벤트
  const handleBlur = (e: any) => {
    onChange?.(e.target.value);
  };

  useEffect(() => {
    if (passwordRef.current) {
      passwordRef.current.name = "uses-pass";
    }
  }, []);

  return (
    <div
      css={css`
        position: relative;
      `}
    >
      <UI.Input
        ref={passwordRef}
        helpText={helpText}
        showHelpText={showHelpText}
        error={error}
        placeholder={placeholder}
        size="medium"
        onBlur={handleBlur}
        showSuffixIcon
        suffixIcon={showPw ? "eyeClosed" : "eye"}
        onChange={(value: string) => value.length <= 16 && onChange?.(value)}
        type={showPw ? "text" : "password"}
        // value={value}
      />
      <PwEyeIconTouchPoint onClick={() => setShowPw(!showPw)}></PwEyeIconTouchPoint>
    </div>
  );
};

export default PasswordInput;
